import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { send } from "emailjs-com";

const Userform = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [sendSuccess, setSendSuccess] = useState(false);

  const sendFormData = async (data, error) => {
    send(
      process.env.REACT_APP_SERVICE_ID,
      process.env.REACT_APP_TEMPLATE_ID,
      data,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    );
    reset();
    setSendSuccess(true);
  };

  return (
    <form
      onSubmit={handleSubmit(sendFormData)}
      className="userform flex flex-col gap-2 mt-6"
    >
      <input
        placeholder="NAME*"
        type="text"
        {...register("name", { maxLength: 30, required: true })}
      />
      {errors.email?.type === "required" && (
        <span className="error-span">Please, enter your name</span>
      )}
      <input
        placeholder="EMAIL*"
        type="email"
        {...register("email", {
          required: true,
          pattern:
            /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
        })}
        aria-invalid={errors.email ? "true" : "false"}
      />
      {errors.email?.type === "required" && (
        <span className="error-span">Please, enter your email</span>
      )}
      {errors.email?.type === "pattern" && (
        <span className="error-span">Please, enter valid email</span>
      )}
      <input
        aria-multiline
        type="text"
        placeholder="MESSAGE*"
        defaultValue=""
        {...register("message")}
      />
      {sendSuccess && (
        <span className="success-span">
          Thanks, your data was processed successfully!
        </span>
      )}
      <button type="submit" className="site-btn mt-4 md:mt-16 mx-auto">
        CONTACT US
      </button>
    </form>
  );
};

export default Userform;
